import * as React from 'react';
import { FilterButton } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const StoreFilters = ({ filters , appliedFilters , toggleFilter , isLoadingResults  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "store-filters__container"
    }, filters.map(({ name: filterKey , options  })=>{
         return React.createElement("div", {
            key: filterKey,
            className: "store-filters__section"
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "subheading1",
            className: "store-filters__section-title"
        }, getLabel(`stores.storeFilters.filters.${filterKey}`)), /*#__PURE__*/ React.createElement("div", {
            className: "store-filters__filters"
        }, options.map(({ name: optionKey , count  })=>{
            var ref;
            const isFilterSelected = !!((ref = appliedFilters[filterKey]) === null || ref === void 0 ? void 0 : ref.find((option)=>option === optionKey
            ));
            const optionName = getLabel(`stores.storeFilters.filters.${filterKey}.${optionKey}`);
            const filterLabel = isFilterSelected ? optionName : `${optionName}${!isLoadingResults ? ` (${count})` : ''}`;
            return /*#__PURE__*/ React.createElement(FilterButton, {
                key: optionName,
                caption: filterLabel,
                icon: isFilterSelected ? 'clear' : undefined,
                isSelected: isFilterSelected,
                onClick: ()=>toggleFilter(filterKey, optionKey)
            });
        })));
    }));
};

export { StoreFilters as default };
//# sourceMappingURL=StoreFilters.js.map
